"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("clipPath", {
        id: "prefix__a",
        children: (0, _jsxRuntime.jsx)("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#prefix__a)",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#FF0076",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M14.094 16.2h-2.856v-5.784l-.852.456h-.48V8.82L11.97 7.8h2.124v8.4Z"
      })]
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};